<block-ui>
    <div class="d-flex flex-row-reverse">
        <button type="button" class="btn btn-light shadow-sm btn-sm ml-2" (click)="StoreCompany()">Guardar</button>
        <!-- <button type="button" class="btn btn-light shadow-sm btn-sm ml-2" (click)="loadCrediserverService()">Ejecutar Servicio (Dev Use)</button> -->
    </div>
    <form [formGroup]="companyForm" class="row">
        <div class="form-group col-6">
            <label>Día del mes para Ejecución </label>
            <input type="text" class="form-control form-control-sm" formControlName="ExecutionDay" inputmode="numeric" pattern="[0-9]*" (input)="FormatInput($any($event).target)">
        </div>
        <div class="form-group col-6">
            <label>Hora del día para ejecución</label>
            <input type="time" class="form-control form-control-sm" formControlName="ExecutionTime">
        </div>
        <div class="form-group col-6">
            <label>Usuario robot CrediServer</label>
            <input type="email" class="form-control form-control-sm" formControlName="CrediServerUser">
        </div>
        <div class="form-group col-6 ">
            <label>Contraseña robot CrediServer</label>
            <div class="input-group form-group">
                <input type="password" class="form-control form-control-sm" formControlName="CrediServerPass" [readonly]="!checkPass">
                <div class="input-group-append">
                    <div class="input-group-text">
                        <input type="checkbox" [checked]="checkPass" id="check-pass" (click)="CheckPass()">
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group col-6">
            <label>Usuario Registro Nacional</label>
            <input type="text" class="form-control form-control-sm" formControlName="RegistroNacionalUser">
        </div>
        <div class="form-group col-6 ">
            <label>Contraseña Registro Nacional</label>
            <div class="input-group form-group">
                <input type="password" class="form-control form-control-sm" formControlName="RegistroNacionalPass" [readonly]="!checkRnpPass">
                <div class="input-group-append">
                    <div class="input-group-text">
                        <input type="checkbox" [checked]="checkRnpPass" id="check-rnp-pass" (click)="CheckRnpPass()">
                    </div>
                </div>
            </div>
        </div>
    </form>
</block-ui>